export default __webpack_public_path__ + "./image/de6f7c93ba1e06b34afc9dbd849d123c.png";